import { useEffect, useState } from 'react'
import { Editor } from '@tiptap/react'
import { isInTable } from '@tiptap/pm/tables'

export function useIsInTable(editor: Editor | null) {
  const [inTable, setInTable] = useState(false)

  useEffect(() => {
    if (!editor) return

    const update = () => {
      setInTable(isInTable(editor.state))
    }

    update()

    editor.on('selectionUpdate', update)
    return () => {
      editor.off('selectionUpdate', update)
    }
  }, [editor])

  return inTable
}
